import React, { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import { stock_report_titles } from '../statics';
import Table from '../../../../../components/table/Table';

const HIDE_DATA_FOR_SOURCES = [
    // Leadomatic
    '5be93e5f683059f77dbcef4c',
    undefined,
];

class ExistingStock extends Component {
    buildMainContent() {
        const { stockData } = this.props;
        const contentExists = lodash.isArray(stockData.existingStock) && stockData.existingStock.length;

        const emptyContent = <span style={{ fontStyle: 'italic', width: '100%' }}>There are no bikes in stock matching this model.</span>;
        const content = contentExists && (
            <Table>
                <thead>
                    <tr>{stock_report_titles.map((title, index) => <th key={index} className="tableHeader">{title}</th>)}</tr>
                </thead>
                <tbody>
                    {
                        stockData.existingStock.map((item, index) => {
                            const url = item.superbike_factory_url ? item.superbike_factory_url.startsWith('https://') ? item.superbike_factory_url : `https://${item.superbike_factory_url}` : '';

                            return (
                                <tr key={index}>
                                    <td>{url && url.length > 0 ? <a href={url} target="_blank-Col">{item.vrm}</a> : item.vrm}</td>
                                    <td>
                                        {item.year}
                                        {' '}
                                        {item.bike_name}
                                    </td>
                                    <td>{item.mileage}</td>
                                    <td>{item.price.purchase_price > 0 ? `£${item.price.purchase_price}` : '-'}</td>
                                    <td>{item.price.retail_price > 0 ? `£${item.price.retail_price}` : '-'}</td>
                                    <td>{item.days_in_stock > 0 ? item.days_in_stock : '-'}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </Table>
        );

        return contentExists ? content : emptyContent;
    }

    render() {
        const { stockData } = this.props;
        const leadSource = lodash.get(this, 'props.ref_lead_source._id');

        return (
            !HIDE_DATA_FOR_SOURCES.includes(leadSource) && (
                <div className="profile__information existingStock">
                    <div className="profile__data valuation">
                        <h3>Existing Stock</h3>
                        <div className="tableWrapper">
                            <div className="profile__contact">
                                {
                                    stockData.isLoading
                                        ? <LinearProgress />
                                        : this.buildMainContent()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = state => ({
    stockData: state.Leads.Lead_profile.Lead_existing_stock,
    ref_lead_source: state.Leads.Lead_profile.Lead_marketing.ref_lead_source,
});

export default connect(mapStateToProps, null)(ExistingStock);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/ExistingStock.js